import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { PainSection } from './components/PainSection';
import { ServicesGrid } from './components/ServicesGrid';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServiceAreas } from './components/ServiceAreas';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { BeforeAfter } from './components/BeforeAfter';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingMessageButton } from './components/FloatingMessageButton';
export function App() {
  return <div className="min-h-screen bg-white font-body text-darkCharcoal" data-id="element-0">
      <Navbar data-id="element-1" />
      <FloatingMessageButton data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <TrustBar data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <PainSection data-id="element-7" />
        <ServicesGrid data-id="element-8" />
        <WhyChooseUs data-id="element-9" />
        <ServiceAreas data-id="element-10" />
        <HowItWorks data-id="element-11" />
        <SocialProof data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}